import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-info-procedimientos-pp',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './info-procedimientos-pp.component.html',
  styleUrl: './info-procedimientos-pp.component.css'
})
export class InfoProcedimientosPPComponent {
  listItems = [
    {
      texto: "Exámenes de laboratorio",
    },
    {
      texto: "Resonancia magnética"
    },
    {
      texto: "Rayos X"
    },
    {
      texto: "Espirometría"
    },
    {
      texto: "Especialidades Médicas"
    },
    {
      texto: "Audiometría"
    },
    {
      texto: "Electrocardiograma"
    }

  ]

}
